export const DASHBOARD_CARDS = 'DASHBOARD_CARDS';
export const DASHBOARD_GMV_PER_DAY = 'DASHBOARD_GMV_PER_DAY';
export const DASHBOARD_MARGIN_PER_DAY = 'DASHBOARD_MARGIN_PER_DAY';
export const DASHBOARD_TOP_PRODUCTS = 'DASHBOARD_TOP_PRODUCTS';
export const DASHBOARD_TOP_CUSTOMERS = 'DASHBOARD_TOP_CUSTOMERS';
